import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function FormulaAdmin({ formula, onSave, endpoint = "/admin/points-formula", title = "Points per Place", desc = "Set how many league points each finishing position earns. New results auto-fill from this table.", unit = "", count = 9, testPrefix = "formula" }) {
  const [places, setPlaces] = useState({});
  const [def, setDef] = useState(0);
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    const base = { ...formula.places };
    for (let i = 1; i <= count; i++) if (base[String(i)] === undefined) base[String(i)] = 0;
    setPlaces(base);
    setDef(formula.default_points ?? 0);
    setShow(!!formula.show_public);
  }, [formula, count]);
  const save = async () => {
    setSaving(true);
    try {
      const cleaned = {};
      Object.entries(places).forEach(([k, v]) => { cleaned[k] = Number(v) || 0; });
      const { data } = await api.put(endpoint, { places: cleaned, default_points: Number(def) || 0, show_public: show });
      onSave(data);
      toast.success("Saved");
    } catch (e) { toast.error("Could not save"); } finally { setSaving(false); }
  };
  const rows = Object.keys(places).sort((a, b) => Number(a) - Number(b));
  return (
    <div className="mt-6 max-w-xl" data-testid={`${testPrefix}-admin`}>
      <div className="bg-navy-paper border border-gold/30 p-6">
        <h3 className="font-display text-lg font-bold text-white mb-2">{title}</h3>
        <p className="text-slate-400 text-sm mb-5">{desc}</p>
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
          {rows.map((p) => (
            <div key={p}>
              <Label className="text-slate-300 text-xs">Place {p}{unit ? ` (${unit})` : ""}</Label>
              <Input type="number" value={places[p]} onChange={(e) => setPlaces({ ...places, [p]: e.target.value })} className="mt-1 rounded-none bg-navy border-slate-700 text-sm" data-testid={`${testPrefix}-place-${p}`} />
            </div>
          ))}
          <div>
            <Label className="text-slate-300 text-xs">All others{unit ? ` (${unit})` : ""}</Label>
            <Input type="number" value={def} onChange={(e) => setDef(e.target.value)} className="mt-1 rounded-none bg-navy border-slate-700 text-sm" data-testid={`${testPrefix}-default`} />
          </div>
        </div>
        <label className="flex items-start gap-3 mt-6 p-4 border border-slate-700 bg-navy cursor-pointer" data-testid={`${testPrefix}-show-public-label`}>
          <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} className="mt-1" data-testid={`${testPrefix}-show-public`} />
          <span>
            <span className="block text-white text-sm font-medium">Show on the Points, Payouts &amp; Structures page</span>
            <span className="block text-slate-500 text-xs mt-0.5">When off, this section is hidden from the public website. Click Save to apply.</span>
          </span>
        </label>
        <Button onClick={save} disabled={saving} className="w-full mt-6 bg-gold text-navy hover:bg-gold-light rounded-none font-bold uppercase tracking-widest text-xs" data-testid={`${testPrefix}-save`}>{saving ? "Saving…" : "Save"}</Button>
      </div>
    </div>
  );
}
